// componente per la visualizzazione e la gestione della side-bar, con tutti i suoi pulsanti e le sue funzioni

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthenticationService } from '../../../../service/authentication.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertService } from 'src/app/service/alert.service';
export interface DialogData {
    text: string;
}
// classe "User" contenente tutte le informazioni utente restituite dal back-end
// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
    username: string;
    telephone: string;
    email: string;
    firstname: string;
    bodyid: string;
    lastname: string;
    profile: string;
    token: string;
}
@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss'],

    // gestione animazioni pulsanti side-bar (dal collapse all'opacità quando si passa sul pulsante col mouse)
    animations: [
        trigger(
            'CollapseAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({ opacity: 0 }),
                        animate('1s ease-out',
                            style({ opacity: 1 }))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({ opacity: 1 }),
                        animate('400ms ease-in',
                            style({ opacity: 0 }))
                    ]
                )
            ]
        )
    ]
})
export class SideBarComponent implements OnInit {
    public user: User;

    // inizializzazione tab corrente, ovvero quale pulsante è stato cliccato
    currentTab = undefined;

    // inizializzazione pulsanti per profilo "Admin": ciascun pulsante ha una rotta (vedere routes.ts), un'icona, un titolo ed un colore
    BUTTONS = [
        {
            link: '',
            icon: 'date_range',
            title: 'Turnazioni reperibili',
            color: 'blue'
        },
        {
            link: '/registries',
            icon: 'perm_contact_calendar',
            title: 'Anagrafiche componenti',
            color: 'green'
        },
        {
            link: '/calls',
            icon: 'track_changes',
            title: 'Chiamate ai reperibili',
            color: 'red'
        },
        {
            link: '/emergencies',
            icon: 'report_problem',
            title: 'Emergenze dagli impianti',
            color: 'cyan'
        },
        {
            link: '/settings',
            icon: 'settings',
            title: 'Impostazioni',
            color: 'grey'
        },
    ];
    BUTTONS3 = [
        {
            link: '',
            icon: 'date_range',
            title: 'Turnazioni reperibili',
            color: 'blue'
        },
        {
            link: '/registries',
            icon: 'perm_contact_calendar',
            title: 'Anagrafiche componenti',
            color: 'green'
        },
        {
            link: '/calls',
            icon: 'track_changes',
            title: 'Chiamate ai reperibili',
            color: 'red'
        },
        {
            link: '/emergencies',
            icon: 'report_problem',
            title: 'Emergenze dagli impianti',
            color: 'cyan'
        },
        {
            link: '/settings',
            icon: 'settings',
            title: 'Impostazioni',
            color: 'grey'
        },
    ];
    BUTTONS2 = [
        {
            link: '',
            icon: 'date_range',
            title: 'Turnazioni reperibili',
            color: 'blue'
        },
        {
            link: '/calls',
            icon: 'track_changes',
            title: 'Chiamate ai reperibili',
            color: 'red'
        },
        {
            link: '/emergencies',
            icon: 'report_problem',
            title: 'Emergenze dagli impianti',
            color: 'cyan'
        },
        // {
        //     link: '/listen',
        //     icon: 'phonelink_ring',
        //     title: 'Ascolto chiamate',
        //     color: 'grey'
        // },
    ];
    constructor(
        private authService: AuthenticationService,
        private ngxService: NgxUiLoaderService,
        private http: HttpClient,
        public dialog: MatDialog
    ) {
    }

    // al richiamo della sidebar viene importato l'utente corrente leggendolo dal componente di autenticazione e viene assegnato un id
    // a tutti gli elementi degli array BUTTONS, BUTTONS2 e BUTTONS3 
    ngOnInit() {
        this.user = this.authService.user;
        // if (!this.user) this.authService.logout()
        let i = 0;
        this.BUTTONS.forEach(ele => {
            ele['id'] = i++;
        });
    }
    onSend() {
        var me = this

        // viene aperto il pop-up col form di inserimento username/mail
        const dialogRef = this.dialog.open(Send, {
            width: '500px',
            data: {text: "", number: ""}
        });

        // alla chiusura del pop-up viene richiamato l'opportuno servizio di recupero mail
        dialogRef.afterClosed().subscribe(result => {
            if (!result) { return; }
            this.http.post<any>('https://sosimperium.multiutilitydelgarda.eu:8001/sms', { text: result.text, number: result.number }).subscribe(data => {
            })
        });
    }
    // metodo di logout: cancella l'utente dallo storage locale e richiama l'opportuno metodo di logout dalla componente di autenticazione
    logOut() {
        localStorage.clear();
        localStorage.removeItem('currentUser');
        this.ngxService.start();
        this.authService.logout();
    }

    // setta sulla variabile currentTab il valore del tab corrente (dunque del pulsante cliccato)
    toggleTab(id) {
        if (this.currentTab !== id) { this.currentTab = id; } else if (this.currentTab == id) { this.currentTab = undefined; }
    }

    // verifica se la tab "id" è attualmente attiva (usato per la gestione delle transizioni tra tab diverse)
    isActiveTab(id) {
        return this.currentTab === id;
    }
    getFullName() {
        return `${this.user.firstname} ${this.user.lastname}`;
    }
}

// componente di recupero credenziali; permette di esporre il pop-up di inserimento username/mail tramite pagina recover.html
@Component({
    selector: 'send',
    templateUrl: 'send.html',
})
export class Send implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<Send>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
    ngOnInit() {
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
}
